import styled, { css } from "styled-components/native";
import { pickStyle as _, pickThemeKey as theme, flexRow } from "utils";
import {
  ContainerWidth,
  CheckBoxSpacing,
  CheckBoxSize,
  CheckBoxMargin,
  CheckedImageHeight,
  CheckedImageWidth,
  LabelFontSize,
  CheckboxWrapperPadding,
} from "./variables";

export const Wrapper = styled.View`
  width: ${_(ContainerWidth) || "100%"};
  margin: 0 auto;
  flex-flow: row wrap;
  justify-content: space-between;
  flex-direction: ${flexRow()};
`;

export const OptionWrapper = styled.View`
  width: ${props =>
    props.$singleLine
      ? "100%"
      : _(CheckBoxSpacing) || "calc((100% / 2) - 70px)"};
  margin-bottom: ${props =>
    props.$singleLine ? "15" : _(CheckBoxMargin) || "30"}px;
`;

export const CheckboxWrapper = styled.TouchableOpacity`
  align-items: center;
  flex-direction: ${flexRow()};
  background-color: ${props =>
    props.$isSelected
      ? theme("selected_option_background")(props)
      : "transparent"};
  border-radius: 2px;
  border: 2px
    ${props =>
      props.$isSelected ? theme("selected_option")(props) : "transparent"};
  padding: ${_(CheckboxWrapperPadding) || "11px 19px"};
`;

export const Checkbox = styled.View`
  width: ${_(CheckBoxSize) || 21}px;
  height: ${_(CheckBoxSize) || 21}px;
  border: 2px solid
    ${props =>
      props.$isSelected
        ? theme("selected_option")(props)
        : theme("option_text")(props)};
  border-radius: ${props => (props.$singleSelect ? "50%" : 2)};
  background-color: ${props =>
    props.$isSelected ? theme("selected_option")(props) : "transparent"};
  position: relative;
  z-index: 1;
  align-items: center;
  justify-content: center;
`;

export const CheckMarkImage = styled.Image`
  height: ${_(CheckedImageHeight) || 15}px;
  width: ${_(CheckedImageWidth) || 14}px;
  resize-mode: cover;
  position: absolute;
  z-index: 2;
  opacity: ${props => (props.$isSelected ? 1 : 0)};
  margin: auto;
  align-items: center;
  justify-content: center;
  tint-color: ${theme("selected_option_background")};
`;

export const Label = styled.Text`
  font-size: ${theme("option_text_size") || _(LabelFontSize) || 18}px;
  color: ${props =>
    props.$isSelected
      ? theme("selected_option")(props)
      : theme("option_text")(props)};
  margin-left: 16px;
  font-family: ${theme("option_text_style") || "Roboto"};
  ${props =>
    props.$RTL
      ? css`
          margin-right: 16px;
        `
      : css`
          margin-left: 16px;
        `}
`;

export const OtherTextWrapper = styled.View`
  margin-top: 20px;
`;
